require('jquery.quicksearch');

// 同意チェックとボタンの連動
$(function () {
  $('#nextBtn').on('click', function () {
    const agree = document.getElementById("agree");
    if (agree.checked) {
      location.href="/register?id=is_step2";
    } else {
      $('.NormalRed').css('display', 'block');
    }
  });
});

// STEP の切替
document.addEventListener('DOMContentLoaded', function () {
  var url = $(location).attr('href');
  if(url.indexOf("?id=") != -1){
    var id = url.split("?id=");
    var num = id[1].slice(-1);
    $('.is_step').css('display', 'none');
    $('.'+id[1]).css('display', 'block');
    if ($('.wpmem_msg p span').hasClass('success')) {
      $('.partners-sec__step li').removeClass('current');
      $('.partners-sec__step li:nth-child(3)').addClass('current');
    } else {
      $('.partners-sec__step li').removeClass('current');
      $('.partners-sec__step li:nth-child('+num+')').addClass('current');
    }
  }
});

// 大分類プルダウン
$(function () {
  $('.partners-sec__searchBox__btn').on('click', function () {
    $(this).toggleClass('open');
    $(this).next().slideToggle();
    if ($(this).hasClass('open')) {
      $(this).children('.actBtn').text('閉じる -');
    } else {
      $(this).children('.actBtn').html('開く +');
    }
  });
});

$(function () {
  // 文字検索
  $('#search_word').quicksearch('.partners-sec__table01 tbody tr', {
    'delay': 100,
    'selector': 'td',
    'minValLength': 2,
    'onAfter': function () {
      // テーブルを削除
      $('.partners-sec__table01 tbody').each(function () {
        if ($(this).children('tr.is_line_show').length == 0) {
          $(this).parent().removeClass('is_table_show');
        }
      });
      //  大分類タイトル削除
      $('.partners-sec__downloadBox').each(function () {
        if ($(this).children('.partners-sec__table01.is_table_show').length == 0) {
          $(this).children('.partners-sec__ttl2').addClass('is_title_noshow');
        }
      });
    },
    'show': function () {
      // 選択オプション取得
      var val1 = $('select[name=children] option:selected').not('.noshow').val();
      // 1行毎に実施
      var val2 = $(this).data('val');
      if(val1 == 0) {
        $(this).addClass('is_line_show'); // 行を表示
        $(this).parent().parent().addClass('is_table_show'); // テーブルを表示
      } else if (val1 != val2) {
        $(this).removeClass('is_line_show');// 行を削除
        $(this).parent().parent().removeClass('is_table_show'); // テーブルを表示
      } else {
        $(this).addClass('is_line_show'); // 行を表示
        $(this).parent().parent().addClass('is_table_show'); // テーブルを表示
      }
      $(this).parent().parent().prev().removeClass('is_title_noshow'); // 大分類タイトルを表示
    },
    'hide': function () {
      $(this).removeClass('is_line_show'); // 該当行を削除
    }
  });

  // 親の select
  $('input[name=category]').on("load change", function () {
    categorySelect();
    childrenSelect();
    $('#search_word').trigger('search');
  });

  // select（子） による絞り込み
  $('select[name=children]').on("load change", function () {
    childrenSelect();
    $('#search_word').trigger('search');
  });

});

// 大分類絞り込み
function categorySelect() {
  var $children = $('.select_children');
  var val1 = $('input[name=category]:checked').data('val');

  if (val1 != 0) {
    // 中分類 select の個別カテゴリ表示
    $children.find('option').each(function () {
      const wrap = $(this).parents().attr("class");
      var val2 = $(this).data('val');
      if (val2 == 0) {
      } else if (val1 != val2) {
        if (wrap !== "wrap") {
          $(this).wrap("<span class='wrap'>");
          $(this).not('.msg').addClass('noshow');
        }
      } else {
        if (wrap == "wrap") {
          $(this).unwrap();
          $(this).not('.msg').removeClass('noshow');
        }
      }
    });

    // 大分類選択時表示絞り込み
    $('.partners-sec__downloadBox').each(function () {
      $(this).show();
      $('.partners-sec__ttl2').removeClass('is_title_noshow'); // 大分類全タイトルを表示
      $('.partners-sec__table01').addClass('is_table_show'); // 全テーブルを表示
      $('.partners-sec__table01 tbody tr').addClass('is_line_show'); // 全行を表示
      if ($(this).data('val') != val1) {
        $(this).hide();
      }
    });

  } else {
    // 中分類 select すべてのカテゴリ表示
    $children.find('option').each(function () {
      const wrap = $(this).parents().attr("class");
      if (wrap == "wrap") {
        $(this).unwrap();
        $(this).not('.msg').removeClass('noshow');
      }
    });
    $children.val(0);

    // 大分類全て表示
    $('.partners-sec__downloadBox').each(function () {
      $(this).show();
      $('.partners-sec__ttl2').removeClass('is_title_noshow'); // 大分類全タイトルを表示
      $('.partners-sec__table01').addClass('is_table_show'); // 全テーブルを表示
      $('.partners-sec__table01 tbody tr').addClass('is_line_show'); // 全行を表示
    });
  }
}

// 中分類絞り込み
function childrenSelect() {
  // 選択オプション取得
  var val1 = $('select[name=children] option:selected').not('.noshow').val();
  $('.partners-sec__ttl2').removeClass('is_title_noshow'); // 大分類全タイトルを表示
  $('.partners-sec__table01').addClass('is_table_show'); // 全テーブルを表示
  $('.partners-sec__table01 tbody tr').addClass('is_line_show'); // 全行を表示
  // 1行毎に実施
  $('.partners-sec__table01 tbody tr').each(function () {
    var val2 = $(this).data('val');
    if(val1 == 0) {
      $(this).addClass('is_line_show'); // 行を表示
      $(this).parent().parent().addClass('is_table_show'); // テーブルを表示
    } else if (val1 != val2) {
      $(this).removeClass('is_line_show');// 行を削除
      $(this).parent().parent().removeClass('is_table_show'); // テーブルを表示
    }
  });
  $('.partners-sec__downloadBox').each(function () {
    // テーブルが表示されていない場合は大分類タイトル非表示
    if ($(this).children('.partners-sec__table01.is_table_show').length == 0) {
      $(this).children('.partners-sec__ttl2').addClass('is_title_noshow');
    }
  });
}

// 郵便番号自動挿入
$('.getPostCode').on('change', function(){
  AjaxZip3.zip2addr('postcode[data][0]', 'postcode[data][1]', 'prefecture', 'city');
});

$('#billing_postcode').on('change', function () {
  AjaxZip3.zip2addr('billing_postcode', '', 'prefecture_name', 'billing_address_1');
});
